export const sexify = number => {
  return `0${number.toString().slice(-9)}`;
};

export const sexifyIntl = number => {
  return number.replace(/\+/g, '%20');
};
